export default __webpack_public_path__ + "static/media/eth.a1804d75.svg";